import type { ChecklistItem as BoardChecklistItem } from '../types/schema'

export type ChecklistBoardAuthorityPartition = {
  supported: BoardChecklistItem[]
  skippedLegacyIds: string[]
}

const FIRESTORE_AUTO_ID_PATTERN = /^[A-Za-z0-9]{20}$/

const isAuthoritativeChecklistNodeId = (
  id: string,
  persistedDocumentIds: ReadonlySet<string>,
) => persistedDocumentIds.has(id) || FIRESTORE_AUTO_ID_PATTERN.test(id)

/**
 * Checklist canvas save is authoritative only for nodes that already exist as
 * real `checklists/{id}` docs in the current session or brand-new nodes that
 * already reserved a real Firestore checklist doc id up front. Legacy embedded
 * checklist mirrors from `elements.checklist[]` are intentionally excluded so
 * they cannot break the modern save batch with rule-invalid writes.
 */
export const partitionChecklistBoardSaveNodes = (
  snapshot: readonly BoardChecklistItem[],
  persistedDocumentIds: ReadonlySet<string>,
): ChecklistBoardAuthorityPartition => {
  const supported: BoardChecklistItem[] = []
  const skippedLegacyIds: string[] = []

  snapshot.forEach((node) => {
    if (isAuthoritativeChecklistNodeId(node.id, persistedDocumentIds)) {
      supported.push(node)
      return
    }
    skippedLegacyIds.push(node.id)
  })

  return { supported, skippedLegacyIds }
}
